interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <div className="flex items-center justify-center gap-2 mt-10 flex-wrap">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 flex items-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line" />上一页
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
            p === page
              ? "bg-primary-600 text-background-50 font-semibold"
              : "border border-background-300 text-foreground-700 hover:bg-background-100"
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 flex items-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100 cursor-pointer whitespace-nowrap"
      >
        下一页<i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}